export default {
    key: 'joch',
    common: {
        productName: 'core.productNames.joch',
        splashMessage: 'offerFlow.splashMessage.joch',
        headingAside: 'offerFlow.headingAside.joch',
    },
    stepDate: {
        heading: 'offerFlow.pages.stepDate.heading.joch',
    },
    stepNumberOfPeople: {
        heading: 'offerFlow.pages.stepNumberOfPeople.heading.common',
        body: 'offerFlow.pages.stepNumberOfPeople.body.common',
        infoModal: {
            heading: 'offerFlow.pages.stepPassengers.epr.infoModal.heading',
            body: 'offerFlow.pages.stepPassengers.epr.infoModal.body',
        },
    },
    stepTripSelection: {
        heading: 'offerFlow.pages.stepTripSelection.heading.common',
    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.p2p',
        body: 'offerFlow.pages.stepPassengers.body.withReductions',
        infoModal: {
            heading: 'offerFlow.pages.stepPassengers.epr.infoModal.heading',
            body: 'offerFlow.pages.stepPassengers.epr.infoModal.body',
        },
    },
} satisfies OfferFlowContent;
